module.exports = __webpack_public_path__ + "img/@img_jisike.30d06d02.png";